module.exports = __webpack_public_path__ + "img/hr-brown-carpet-grass-06.3a2b79b3.png";